import { render, staticRenderFns } from "./CompanyBranding.vue?vue&type=template&id=25515f0c&"
import script from "./CompanyBranding.vue?vue&type=script&lang=js&"
export * from "./CompanyBranding.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBranding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports